let domain = 'anban_pms'

let storageConfig = {
  userId: domain + '_PortalContext_UserId',
  accessToken: domain + '_PortalContext_AccessToken',
  hotelId: domain + '_PortalContext_HotelId',
  userInfo: domain + '_PortalContext_UserInfo',
  hotelInfo: domain + '_PortalContext_HotelInfo',
  hotelList: domain + '_PortalContext_HotelList',
  fromRoute: domain + '_PortalContext_FromRoute',
  roomStateTaskIds: domain + '_PortalContext_roomStateTaskIds',
  roomPriceTaskIds: domain + '_PortalContext_roomPriceTaskIds',
  cityCn: domain + '_PortalContext_cityCn',

}

export function setCache(key: keyof typeof storageConfig, value: object) {
  if (typeof value === 'undefined') {
    return
  }
  localStorage.setItem(storageConfig[key], JSON.stringify(value))
}

export function getCache(key: keyof typeof storageConfig) {
  const realKey = storageConfig[key]
  const value = localStorage.getItem(realKey) || ''

  if (value && value !== 'undefined') {
    return JSON.parse(value)
  }
  return null
}

/**
 * @description 设置localStorage
 * @param {String} key localStorage的key
 * @param {*} value localStorage的value
 */
function setLocalStorage(key, value) {
  if (typeof value === 'undefined') {
    return
  }
  localStorage.setItem(key, JSON.stringify(value))
}

/**
 * @description 获取localStorage
 * @param {String} key 获取localStorage的key
 * @returns {*} 获取到的结果，没有值返回null
 */
function getLocalStorage(key = '') {
  const val = localStorage.getItem(key) || 'null'
  return JSON.parse(val === 'undefined' ? 'null' : val)
}

function clearLocalStorage() {
  localStorage.clear()
}

function getUserId() {
  return getLocalStorage(storageConfig.userId)
}

function setUserId(userId) {
  setLocalStorage(storageConfig.userId, userId)
}

function getAccessToken() {
  return getLocalStorage(storageConfig.accessToken)
}

function setAccessToken(accessToken) {
  setLocalStorage(storageConfig.accessToken, accessToken)
}

function setHotelId(hotelId) {
  setLocalStorage(storageConfig.hotelId, hotelId)
}

function setHotelCityCn(cityCn) {
  setLocalStorage(storageConfig.cityCn, cityCn)
}

function getHotelId() {
  return getLocalStorage(storageConfig.hotelId)
}

function setUserInfo(userInfo) {
  setLocalStorage(storageConfig.userInfo, userInfo)
}

function getUserInfo() {
  return getLocalStorage(storageConfig.userInfo)
}

function setHotelInfo(hotelInfo) {
  setLocalStorage(storageConfig.hotelInfo, hotelInfo)
}

function getHotelInfo() {
  return getLocalStorage(storageConfig.hotelInfo)
}

function setHotelList(hotelList) {
  setLocalStorage(storageConfig.hotelList, hotelList)
}

function getHotelList() {
  return getLocalStorage(storageConfig.hotelList)
}

function setFromRoute(fromRoute) {
  setLocalStorage(storageConfig.fromRoute, fromRoute)
}

function getFromRoute() {
  return getLocalStorage(storageConfig.fromRoute)
}

let abLocalStorage = {
  storageConfig,
  setLocalStorage,
  getLocalStorage,
  getUserId,
  setUserId,
  getAccessToken,
  setAccessToken,
  setHotelId,
  setHotelCityCn,
  getHotelId,
  setUserInfo,
  getUserInfo,
  setHotelInfo,
  getHotelInfo,
  setHotelList,
  getHotelList,
  setFromRoute,
  getFromRoute,
  clearLocalStorage
}

export default abLocalStorage
